import React, { Component, Fragment } from 'react';
import PhoneInput from 'react-phone-number-input/max';
import styled from 'styled-components';
import * as S from './styles';
import { Flex, Box, Text } from './components';

const StyledPhoneInput = styled(PhoneInput)`
  & > input {
    width: 100%;
    height: 33px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 0.375rem 0.75rem;
  }
`;
class ADP_HomeOrgUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  dependsOnCompanyCode(value) {
    return (
      value === 'Department'
      || value === 'HomeDepartment'
      || value === 'HomeCostNumber'
    );
  }

  filteredCodeList(value, codeList) {
    if (!(value === 'HomeDepartment' || value === 'HomeCostNumber')) {
      return codeList;
    }

    const { companyCode } = this.props;

    return codeList.filter((code) => code.foreignKey === companyCode);
  }

  render() {
    const {
      question,
      value,
      title,
      errorMessage,
      deletable,
      onDeleteRow,
      disabled,
      reviewActions,
      onCheckEdit,
      isEditChecked,
      companyCode,
    } = this.props;
    const isRequired = !!question.is_required;

    const typeCodeField = question.fields[0];
    const nameCodeField = question.fields[1];

    const typeCodeValue = value[typeCodeField.key];
    let typeCodeKey = typeCodeValue;
    if (!nameCodeField.code_lists[typeCodeValue]) {
      typeCodeKey = nameCodeField.key.replace('/nameCode/code', `/nameCode/${typeCodeValue}`);
    }

    return (
      <S.QuestionWrapper mb="20px" hasError={errorMessage}>
        <Flex alignItems="center">
          <Flex justifyContent="space-between" alignItems="center" width={1}>
            <S.QuestionLabel isRequired={isRequired}>
              {title}
            </S.QuestionLabel>
            {reviewActions.indexOf('edit') !== -1
              && (
              <Flex alignItems="center">
                <input
                  // disabled={hrSubmission.status === 'not_started'}
                  type="checkbox"
                  checked={isEditChecked}
                  onChange={(e) => {
                    onCheckEdit(e.target.checked);
                  }}
                />
                <Box mr={1} />
                <Text fontSize="12px">
                  Edit
                </Text>
              </Flex>
              )}
          </Flex>
        </Flex>
        {/* {formControl} */}
        <Flex alignItems="center">
          <S.Select
            disabled={disabled}
            value={typeCodeValue}
            style={{ width: typeCodeValue ? '50%' : '100%' }}
            onChange={(e) => {
              this.props.onChange({
                name: this.props.name,
                value: e.target.value,
                fieldKey: typeCodeField.key,
              });
            }}
          >
            <option disabled value="" style={{ display: 'none' }} key={0}>
              Select from dropdown
            </option>
            {typeCodeField.options
              && typeCodeField.options.map((option, idx) => (
                <option value={option.code || option.codeValue} key={idx}>
                  {option.name || option.shortName || option.longName || option.valueDescription}
                </option>
              ))}
          </S.Select>
          {typeCodeValue
            && (
            <S.Select
              disabled={disabled}
              ml={10}
              value={value[nameCodeField.key]}
              onChange={(e) => {
                this.props.onChange({
                  name: this.props.name,
                  value: e.target.value,
                  fieldKey: nameCodeField.key,
                });
              }}
              style={{
                display: this.dependsOnCompanyCode(typeCodeValue) && !companyCode ? 'none' : 'block',
                width: '50%',
              }}
            >
              {typeCodeValue === 'Department'
                && companyCode
                && (
                <>
                  <option disabled value="" style={{ display: 'none' }} key={0}>
                    Select from dropdown
                  </option>
                  {nameCodeField.code_lists[typeCodeValue]
                    && nameCodeField.code_lists[typeCodeValue][companyCode]
                    && nameCodeField.code_lists[typeCodeValue][companyCode].map((option, idx) => (
                      <option value={option.codeValue} key={idx}>
                        {option.shortName || option.longName || option.valueDescription}
                      </option>
                    ))}
                </>
                )}
              {typeCodeValue !== 'Department'
                && (
                <>
                  <option disabled value="" style={{ display: 'none' }} key={0}>
                    select from dropdown
                  </option>

                  {nameCodeField.code_lists[typeCodeKey]
                    && this.filteredCodeList(typeCodeValue, nameCodeField.code_lists[typeCodeKey]).map((option, idx) => (
                      <option value={option.codeValue} key={idx}>
                        {option.shortName || option.longName || option.valueDescription}
                      </option>
                    ))}
                </>
                )}
            </S.Select>
            )}
          {deletable
            && (
            <S.DeleteButton
              ml="8px"
              onClick={(e) => {
                e.preventDefault();
                onDeleteRow();
              }}
            />
            )}
        </Flex>
        {
          this.dependsOnCompanyCode(typeCodeValue) && !companyCode
          && <S.QuestionErrorMessage>Please select Company Code first.</S.QuestionErrorMessage>
        }
        {errorMessage && <S.QuestionErrorMessage>{errorMessage}</S.QuestionErrorMessage>}
      </S.QuestionWrapper>
    );
  }
}

export default ADP_HomeOrgUnit;

ADP_HomeOrgUnit.defaultProps = {
  reviewActions: [],
};
